import { render, staticRenderFns } from "./StandardWidget.vue?vue&type=template&id=2d96e29d"
import script from "./StandardWidget.vue?vue&type=script&lang=js"
export * from "./StandardWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports